export default __webpack_public_path__ + "static/media/avatar-keys_club_bot.8bb29621.png";